import React from "react";
import { Image, Center, Text, VStack, ChakraProvider } from "@chakra-ui/react";
import colors from "app/colors";
import { chakraTheme } from "modules/providers/chakra-provider/chakra-theme";
import { LogoIcon } from "modules/icons";
import { MAINTENANCE_PAGE_Z_INDEX } from "../providers/chakra-provider/chakra-portal-stack";

const MaintenancePage = () => (
  <ChakraProvider theme={chakraTheme} portalZIndex={MAINTENANCE_PAGE_Z_INDEX}>
    <Center
      h="100dvh"
      w="full"
      backgroundColor={colors.darkBlue}
      textAlign="center"
    >
      <VStack w="full">
        <LogoIcon boxSize={300} />
        <Image src="/under_maintenance.gif" />
        <Text color={colors.yellowDark} pt={20} fontSize={52} fontWeight={700}>
          We'll be back soon!
        </Text>
        <Text color={colors.white} fontSize={28}>
          Synco is undergoing brief scheduled maintenance.
        </Text>
        <Text color={colors.white} fontSize={18}>
          During this time the Synco mobile app and desktop website will be
          offline. We appreciate your patience as we upgrade Synco's
          functionality.
        </Text>
      </VStack>
    </Center>
  </ChakraProvider>
);

MaintenancePage.prefersFullScreenLayout = true;

export default MaintenancePage;
